import { h, render } from 'preact';
import { initFrame, sendFrameHeight, initFrameAndPoll } from '@newswire/frames';
import CategoryComparison from '../components/CategoryComparison.js';

render(<CategoryComparison />, document.getElementById("category-comparison"));
initFrameAndPoll(200);

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
